import { action, observable } from "mobx";
import type { ToastPosition } from "react-bootstrap/ToastContainer";

class SessionStore {
  @observable accessor loginRequired = false;

  @action requireLogin() {
    this.loginRequired = true;
  }
}

export const sessionStore = new SessionStore();

// Local Constants
export const LEVEL_SUCCESS = "success";
export const LEVEL_ERROR = "error";

export interface Notification {
  message: string;
  level: string;
  title?: string;
  timeout?: number;
}

class NotificationStore {
  @observable accessor notifications: Notification[] = [];
  @observable accessor position: ToastPosition = "bottom-end";

  @action notifySuccess(message: string, title?: string) {
    this.notifications.push({
      message,
      level: LEVEL_SUCCESS,
      title,
      timeout: 5000, // seconds
    });
  }

  @action notifyError(message: string, title?: string) {
    this.notifications.push({
      message,
      level: LEVEL_ERROR,
      title,
    });
  }
}

export const notificationStore = new NotificationStore();
